import React, {useMemo} from "react";

import CASO from "../../../utils/IMG/OUTRAS/caso.png";
import PORTO from "../../../utils/IMG/OUTRAS/porto.png";
import PACOTE from "../../../utils/IMG/OUTRAS/pacote.png";

import { useTranslation } from "react-i18next";

import "../../../utils/font-roboto.scss";
import "./index.scss";

const SobreNos = () => {
      const { t, i18n  } = useTranslation();
  
  const CardServico = ({ texto, img }) => {
    return (
      <div className="item-servico px20">
        <div className="texto bold">{texto}</div>
        <div className="imagem" style={{ backgroundImage: `url(${img})` }} />
      </div>
    );
  };

  const ARRAY_SOBRE_NOS = [
  {
    dsc_texto: t('sobre_nos.esquerdo.dsc_texto_1'),
    src_img: PACOTE,
  },
  {
    dsc_texto: t('sobre_nos.esquerdo.dsc_texto_2'),
    src_img: CASO,
  },
  {
    dsc_texto: t('sobre_nos.esquerdo.dsc_texto_3'),
    src_img: PORTO,
  },
];

 const ARRAY_TEXTO_DESTAQUE_SOBRE_NOS = useMemo(() => [
      t('sobre_nos.direito.destaque'),
  ], [t, i18n.language]);

   const ARRAY_TEXTO_SOBRE_NOS = useMemo(() => [
    t('sobre_nos.direito.texto.dsc_texto_1'),
    t('sobre_nos.direito.texto.dsc_texto_2'),
    t('sobre_nos.direito.texto.dsc_texto_3'),
  ], [t, i18n.language]);
  
  return (
    <div className="sobre-nos">
      <div className="servicos">
        {ARRAY_SOBRE_NOS?.map((item, index) => {
          return (
            <CardServico
              key={index}
              texto={item?.dsc_texto}
              img={item?.src_img}
            />
          );
        })}
      </div>
      <div className="texto-descricao">
        <div className="bold px32">
          {ARRAY_TEXTO_DESTAQUE_SOBRE_NOS?.map((item, index) => {
            return <p key={index}>{item}</p>;
          })}
        </div>
        <div className="texto-dois regular px20">
          {ARRAY_TEXTO_SOBRE_NOS?.map((item, index) => {
            return <p key={index}>{item}</p>;
          })}
        </div>
      </div>
    </div>
  );
};

export default SobreNos;
